/* GROUP CHAT ALERTS IN THE BROWSER (Max 02/11, Tina: "does every message alert the members so they log in right away?"):
   the unread count in the tab's title — "(3) HEVN PORTAL" — and, for whoever switches it on, the browser's own desktop
   notification for a new message while the portal is open in some tab. The switch is this browser's (it asks the
   browser's permission); the header's minute poll (Header.jsx) drives both. */
const KEY = 'gccDesktopAlerts';

export const desktopSupported = () => typeof window !== 'undefined' && 'Notification' in window;
export const desktopOn = () => {
  try { return desktopSupported() && Notification.permission === 'granted' && localStorage.getItem(KEY) === '1'; } catch (e) { return false; }
};
/* turning it on asks the browser once; a refusal is the browser's to undo (its site settings), and we say so */
export const setDesktop = async (on) => {
  if (!desktopSupported()) return 'unsupported';
  try {
    if (!on) { localStorage.setItem(KEY, '0'); return 'off'; }
    const p = Notification.permission === 'granted' ? 'granted' : await Notification.requestPermission();
    if (p !== 'granted') { localStorage.setItem(KEY, '0'); return 'denied'; }
    localStorage.setItem(KEY, '1');
    return 'on';
  } catch (e) { return 'unsupported'; }
};

/* "(n) " in front of the tab's own title, whatever the page set it to */
export const titleCount = (n) => {
  try {
    const base = document.title.replace(/^\(\d+\+?\)\s*/, '');
    document.title = n > 0 ? `(${n > 99 ? '99+' : n}) ${base}` : base;
  } catch (e) { /* no document */ }
};

/* ONE NOTIFICATION PER ROOM, not one per message (Max 02/11: "nhắn nhiều tin liên tục từ 1 group chat thì chỉ nên hiện 1
   thông báo"): a room pops once, then stays quiet however many follow, until it is read — here or on any other device, which
   the server's list of waiting rooms tells us. Nothing pops while the person is looking at that room. The first answer after a
   page load only marks what already waits: a reload must not pop the same old rooms again. */
const told = new Set();   // rooms already popped and still unread
let primed = false;
export const notifyNew = (d, { onOpen } = {}) => {
  const rooms = Array.isArray(d && d.rooms) ? d.rooms : [];
  const waiting = new Set(rooms.map((x) => Number(x.roomPk)));
  [...told].forEach((pk) => { if (!waiting.has(pk)) told.delete(pk); });
  if (!primed) { primed = true; waiting.forEach((pk) => told.add(pk)); return; }
  const on = desktopOn();
  rooms.forEach((x) => {
    const pk = Number(x.roomPk);
    if (told.has(pk)) return;
    const looking = !document.hidden && window.location.pathname === '/gcc' && new URLSearchParams(window.location.search).get('room') === String(pk);
    if (looking) return;
    told.add(pk);
    if (!on) return;
    try {
      const more = Number(x.n) > 1 ? ` (+${Number(x.n) - 1})` : '';
      const n = new Notification(`${x.who} · ${x.room}${more}`, { body: String(x.body || '').replace(/\s+/g, ' ').slice(0, 160), tag: `gcc-${pk}` });
      n.onclick = () => { window.focus(); if (onOpen) onOpen(pk); n.close(); };
    } catch (e) { /* a browser that refuses the constructor (some mobiles) */ }
  });
};
